export const ALERT_TYPES = {
  form9Needed: 'form9_needed',
  scheduledHearing: 'scheduled_hearing',
  hearingNoShow: 'hearing_no_show',
  heldForEvidence: 'held_for_evidence',
  cavcOption: 'cavc_option',
  rampEligible: 'ramp_eligible',
  rampIneligible: 'ramp_ineligible',
  decisionSoon: 'decision_soon',
  blockedByVso: 'blocked_by_vso',
  evidentiaryPeriod: 'evidentiary_period',
  amaPostDecision: 'ama_post_decision',
};

export const AOJS = {
  vba: 'vba',
  vha: 'vha',
  nca: 'nca',
  other: 'other',
};

export const APPEAL_TYPES = {
  legacy: 'legacyAppeal',
  supplementalClaim: 'supplementalClaim',
  higherLevelReview: 'higherLevelReview',
  appeal: 'appeal',
};

export const appealTypes = Object.values(APPEAL_TYPES);

export const appealsAvailability = {
  USER_FORBIDDEN_ERROR: 'USER_FORBIDDEN_ERROR',
  RECORD_NOT_FOUND_ERROR: 'RECORD_NOT_FOUND_ERROR',
  VALIDATION_ERROR: 'VALIDATION_ERROR',
  BACKEND_SERVICE_ERROR: 'BACKEND_SERVICE_ERROR',
  FETCH_APPEALS_ERROR: 'FETCH_APPEALS_ERROR',
  AVAILABLE: 'AVAILABLE',
};

export const claimsAvailability = {
  AVAILABLE: 'AVAILABLE',
  UNAVAILABLE: 'UNAVAILABLE',
};

export const DOCKET_TYPES = {
  directReview: 'directReview',
  evidenceSubmission: 'evidenceSubmission',
  hearingRequest: 'hearingRequest',
};

export const EVENT_TYPES = {
  claimDecision: 'claim_decision',
  nod: 'nod',
  soc: 'soc',
  form9: 'form9',
  ssoc: 'ssoc',
  certified: 'certified',
  hearingHeld: 'hearing_held',
  hearingNoShow: 'hearing_no_show',
  transcript: 'transcript',
  bvaDecision: 'bva_decision',
  cavcDecision: 'cavc_decision',
  remandReturn: 'remand_return',
  rampNotice: 'ramp_notice',
  fieldGrant: 'field_grant',
  withdrawn: 'withdrawn',
  failureToRespond: 'ftr',
  rampOptIn: 'ramp',
  death: 'death',
  merged: 'merged',
  reconsideration: 'reconsideration',
  vacated: 'vacated',
  otherClose: 'other_close',
  amaNod: 'ama_nod',
  docketChange: 'docket_change',
  distributedToVlj: 'distributed_to_vlj',
  bvaDecisionEffectuation: 'bva_decision_effectuation',
  dtaDecision: 'dta_decision',
  scRequest: 'sc_request',
  scDecision: 'sc_decision',
  scOtherClose: 'sc_other_close',
  hlrRequest: 'hlr_request',
  hlrDecision: 'hlr_decision',
  hlrDtaError: 'hlr_dta_error',
  hlrOtherClose: 'hlr_other_close',
  statutoryOptIn: 'statutory_opt_in',
};

export const ISSUE_STATUS = {
  fieldGrant: 'field_grant',
  withdrawn: 'withdrawn',
  allowed: 'allowed',
  denied: 'denied',
  remand: 'remand',
  cavcRemand: 'cavc_remand',
};

// Claim type codes for disability compensation claims. Used by
// isDisabilityCompensationClaim() and getShowEightPhases() to decide
// whether to render the 8-phase claim status display.
export const disabilityCompensationClaimTypeCodes = [
  '010INITMORE8',
  '010LCMPPIDES',
  '010LCOMP',
  '010LCOMPBDD',
  '010LCOMPD2D',
  '010LCOMPDBDD',
  '010LCOMPIDES',
  '010NADIDES8',
  '020BDDNO',
  '020CLMINC',
  '020CPHLP',
  '020CPHLPPMC',
  '020DBDDNO',
  '020EPDSUPP',
  '020IDESRRNAD',
  '020NADIDESNO',
  '020NEW',
  '020NEWIDES',
  '020NEWPMC',
  '020NHPNH10',
  '020NI',
  '020PNI',
  '020PREDSUPP',
  '020RCOMP',
  '020RI',
  '020RN',
  '020RRNADIDES',
  '020RSCDTH',
  '020RSCDTHPMC',
  '020SD2D',
  '020SMB',
  '020SUPP',
  '110INITLESS8',
  '110LCMP7IDES',
  '110LCOMP7',
  '110LCOMP7BDD',
  '110LCOMPD2D',
  '110LCOMPDBDD',
  '110LCOMPIDES',
  '110NADIDES7',
];

// Claim type codes for dependency claims that involve requests to add or
// remove a dependent (a subset of the larger list of all claim type codes
// for the "Dependency" claim type). These codes are used to render a more
// specific title for the claim (e.g., "Request to add or remove a
// dependent" rather than just "Claim for dependency").
export const addOrRemoveDependentClaimTypeCodes = [
  '130DPNDCYAUT',
  '130DPNAUTREJ',
  '130SCHATTAUT',
  '130SCHAUTREJ',
  '130ADOD2D',
  '130ADSD2D',
  '130DAD2D',
  '130DARD2D',
  '130PDARD2D',
  '130PSARD2D',
  '130SAD2D',
  '130SARD2D',
  '130DPNDCY',
  '130DCY674',
  '130DCY686',
  '130DPV0538',
  '130DRASDP',
  '130DPNEBNADJ',
  '130DPEBNAJRE',
  '130SCHATTEBN',
  '130PDA',
  '130PDAE',
  '130PSA',
  '130PSAE',
  '130DPNPMCAUT',
  '130DPMCAUREJ',
  '130SCPMAUREJ',
  '130DV0538PMC',
  '130DPNDCYPMC',
  '130DCY674PMC',
  '130DV05378PMC',
  '130SSRDPMC',
  '130SSRDPMCE',
  '130DAEBNPMC',
  '130DAEBNPMCR',
  '130SCAEBNPMC',
  '130SCAEBPMCR',
  '130PDAJPMC',
  '130PDAJEXPMC',
  '130PSCHAPMC',
  '130PSCHAEPMC',
  '130RD',
  '130SSRD',
  '130SSRDE',
  '130SCHEBNREJ',
];

// Claim type codes for Dependency and Indemnity Compensation (DIC) claims.
export const DICClaimTypeCodes = ['290DICEDPMC', '020SMDICPMC', '020IRDICPMC'];

// Claim type codes for survivors pension claims.
export const survivorsPensionClaimTypeCodes = [
  '190ORGDPN',
  '190ORGDPNPMC',
  '190AID',
  '140ISD',
  '687NRPMC',
];

// Claim type codes for veterans pension claims.
export const veteransPensionClaimTypeCodes = [
  '180AILP',
  '180ORGPENPMC',
  '180ORGPEN',
];

// Provider identifiers used to detect CHAMPVA claims via the provider field
// on a claim's attributes. Used by isChampvaProviderClaim() and the related
// claimStatusMeta helpers.
export const CHAMPVA_PROVIDERS = new Set([
  'ivc_champva',
  'ivcchampvabenefitsclaimsprovider',
]);

// Claim type codes for pension claims that get the 8-phase claim status
// display. Used by isEightStepPensionClaim() and getShowEightPhases().
export const eightStepPensionClaimTypeCodes = [
  '020SMDICPMC',
  '180AILP',
  '180ORGPEN',
  '180ORGPENPMC',
];

// All pension claim type codes, regardless of 8-phase display. Used for
// pension-specific titles.
export const pensionClaimTypeCodes = [
  '190ORGDPN',
  '190ORGDPNPMC',
  '190AID',
  '140ISD',
  '290DICEDPMC',
  '020SMDICPMC',
  '020IRDICPMC',
  '687NRPMC',
  '150ELECPMC',
  '150INCNWPMC',
  '150INCPMC',
  '120INCPMC',
  '150NWTHPMC',
  '120SUPHCDPMC',
  '120ILCP7PMC',
  '120SMPPMC',
  '150MERPMC',
  '120ASMP',
  '120ARP',
  '150AIA',
  '600APCDP',
  '600PCDPPM',
  '696MROCPMC',
  '180AILP',
  '180ORGPENPMC',
  '180ORGPEN',
];

export const programAreaMap = {
  compensation: 'disability compensation',
  pension: 'pension',
  insurance: 'insurance',
  loan_guaranty: 'loan guaranty', // eslint-disable-line camelcase
  education: 'education',
  vre: 'vocational rehabilitation and employment',
  medical: 'health care',
  burial: 'burial benefits',
  fiduciary: 'fiduciary',
};

export const STATUS_TYPES = {
  amaRemand: 'ama_remand',
  atVso: 'at_vso',
  bvaDecision: 'bva_decision',
  bvaDecisionEffectuation: 'bva_decision_effectuation',
  bvaDevelopment: 'bva_development',
  death: 'death',
  decisionInProgress: 'decision_in_progress',
  evidentiaryPeriod: 'evidentiary_period',
  fieldGrant: 'field_grant',
  ftr: 'ftr',
  hlrClosed: 'hlr_closed',
  hlrDtaError: 'hlr_dta_error',
  hlrDecision: 'hlr_decision',
  hlrReceived: 'hlr_received',
  merged: 'merged',
  onDocket: 'on_docket',
  otherClose: 'other_close',
  pendingCertification: 'pending_certification',
  pendingCertificationSsoc: 'pending_certification_ssoc',
  pendingForm9: 'pending_form9',
  pendingHearingScheduling: 'pending_hearing_scheduling',
  pendingSoc: 'pending_soc',
  postBvaDtaDecision: 'post_bva_dta_decision',
  ramp: 'ramp',
  reconsideration: 'reconsideration',
  remand: 'remand',
  remandReturn: 'remand_return',
  remandSsoc: 'remand_ssoc',
  scClosed: 'sc_closed',
  scDecision: 'sc_decision',
  scReceived: 'sc_received',
  scheduledHearing: 'scheduled_hearing',
  statutoryOptIn: 'statutory_opt_in',
  stayed: 'stayed',
  withdrawn: 'withdrawn',
};
